import { render, staticRenderFns } from "./TableCellWrapper.vue?vue&type=template&id=5748b1ab&scoped=true&functional=true&"
import script from "./TableCellWrapper.vue?vue&type=script&lang=js&"
export * from "./TableCellWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TableCellWrapper.vue?vue&type=style&index=0&id=5748b1ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5748b1ab",
  null
  
)

export default component.exports